/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { Text, View, type StyleProp, type ViewStyle } from 'react-native';
import { surfaceCardStyles as styles } from './surfaceCards.styles';

type Props = {
  children: React.ReactNode;
  title?: string;
  hint?: string;
  /** Hairline superior para separar de contenido previo en la misma card. */
  dividerTop?: boolean;
  wrapStyle?: StyleProp<ViewStyle>;
  gridStyle?: StyleProp<ViewStyle>;
  footer?: React.ReactNode;
};

/** Contenedor de métricas embebidas — una sola superficie, sin KpiStrip anidado. */
export function EmbeddedMetricGrid({
  children,
  title,
  hint,
  dividerTop = false,
  wrapStyle,
  gridStyle,
  footer,
}: Props) {
  return (
    <View style={[dividerTop && styles.embeddedMetricShell, wrapStyle]}>
      {title || hint ? (
        <View style={styles.embeddedMetricHeader}>
          {title ? <Text style={styles.embeddedMetricTitle}>{title}</Text> : null}
          {hint ? <Text style={styles.embeddedMetricHint}>{hint}</Text> : null}
        </View>
      ) : null}
      <View style={[styles.embeddedMetricRow, gridStyle]}>{children}</View>
      {footer ? <View style={styles.embeddedMetricFooter}>{footer}</View> : null}
    </View>
  );
}
